export default "__VITE_ASSET__5v6aNI5n__"